const throttle = function(func,ms,context) {
  let wait = false;
  return function() {
    let args = Array.prototype.slice.call(arguments);
    let later = () => func.apply(context || window,args);

    if(!wait) {
      let to;
      later();
      wait = true;
      return to = window.setTimeout(() => wait = false
      , ms);
    }
  };
};

export default throttle;
